import restClient from '../restClient';
export const DYNAMIC_SECTION_SUBMITTED = 'DYNAMIC_SECTION_SUBMITTED';
export const DYNAMIC_SECTION_SAVE_ERROR = 'DYNAMIC_SECTION_SAVE_ERROR';
export const DYNAMIC_SECTION_CLEAR = 'DYNAMIC_SECTION_CLEAR';
const dynamicSectionSubmitted = sectionIndex => ({
  sectionIndex,
  type: DYNAMIC_SECTION_SUBMITTED
});
const dynamicSectionSubmitFailed = (error, sectionIndex) => ({
  error,
  sectionIndex,
  type: DYNAMIC_SECTION_SAVE_ERROR
});
const dynamicSectionClear = sectionIndex => ({
  sectionIndex,
  type: DYNAMIC_SECTION_CLEAR
});
export const submitDynamicSection = (answers, sectionIndex) => async dispatch => {
  try {
    await restClient.submitDynamicSection(answers);
    dispatch(dynamicSectionSubmitted(sectionIndex));
  } catch (e) {
    dispatch(dynamicSectionSubmitFailed(e, sectionIndex));
  }
};
export const clearDynamicSection = sectionIndex => async dispatch => {
  dispatch(dynamicSectionClear(sectionIndex));
};